// POST /admin/questions 응답(DFQuestions.to_dict)은 번역을 _ea/_em, _ca/_cm 컬럼 키로 준다.
// 화면 store 는 GET /questions 와 같은 규칙(manual 우선, None 일 때만 auto)으로 합친 _e/_c 를 쓴다.
// 응답에 해당 키가 하나도 없으면 아무것도 돌려주지 않아 기존 값이 유지된다.
const FIELDS = [
    ['question_name_e', 'question_name_em', 'question_name_ea'],
    ['question_name_c', 'question_name_cm', 'question_name_ca'],
    ['question_infobox_e', 'question_infobox_em', 'question_infobox_ea'],
    ['question_infobox_c', 'question_infobox_cm', 'question_infobox_ca'],
];

function mapSavedTranslations(saved) {
    const result = {};
    if (!saved) return result;
    FIELDS.forEach(([target, manual, auto]) => {
        if (manual in saved || auto in saved) {
            const value = saved[manual] != null ? saved[manual] : saved[auto];
            result[target] = value === undefined ? null : value;
        }
    });
    return result;
}

// 테스트(node --test)가 require 로 읽으므로 CommonJS 로 내보낸다 (errorMessage.js 와 같은 관례).
module.exports = { mapSavedTranslations };
